enum MaturityReminderStatusEnum {
    NinetyDays = '90_DAYS',
    SixtyDays = '60_DAYS',
    ThirtyDays = '30_DAYS',
}

export default MaturityReminderStatusEnum;
